import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    COACHTYPE_LIST_START: 'COACHTYPE_LIST_START',
    COACHTYPE_LIST_SUCCESS: 'COACHTYPE_LIST_SUCCESS',
    COACHTYPE_LIST_FAILED: 'COACHTYPE_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const coachTypeListStart = (data) => ({
   type: actionType.COACHTYPE_LIST_START,
   payload: data
})

export const coachTypeListSuccess = (data) => ({
    type: actionType.COACHTYPE_LIST_SUCCESS,
    payload: data
})

export const coachTypeListFailed = (data) => ({
    type: actionType.COACHTYPE_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function coachTypeListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.COACHTYPE_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.COACHTYPE_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.COACHTYPE_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* coachTypeListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allCoachtypes = response.data.data.allCoachtypes.Coachtypes ? response.data.data.allCoachtypes.Coachtypes : null
       yield put(coachTypeListSuccess(allCoachtypes));
    } else {
      messagePopup('','Coachtype List failed','error')   
      yield put(coachTypeListFailed('Coachtype List failed')) 
    }
   } catch (error) {
     messagePopup('','Coachtype List failed','error')   
     yield put(coachTypeListFailed('Coachtype List failed')) 
   }
}

export function* watchCoachTypeListSaga(){
    yield takeEvery(actionType.COACHTYPE_LIST_START, coachTypeListSaga)
}